const CDN_URL = process.env.REACT_APP_CDN_URL;

const machine = {
  title: "Introducing the wallPen® E2",
  description:
    "The gold standard in vertical wall printing, built 100% in Germany. The wallPen E2 delivers precision, efficiency, and durability for professional-quality prints on any surface.",

  heroVideo: `${CDN_URL}/videos/Header_neu.mp4`,
  demoVideo: "https://www.youtube.com/watch?v=HxDrcg0Oh2k",

  divider: [
    {
      title: "Training Provided",
      description:
        "2 days in person training machine and business operation training",
    },
    {
      title: "Extended Warranty",
      description:
        "When you upgrade to the 48 months wallpen software pro memberships",
    },
    {
      title: "Ongoing Support",
      description:
        "Wallpen machine operators have a company that support all their technical and mechanical needs",
    },
    {
      title: "Turn-Key Solution",
      description:
        "We offer the turn key all your digital assets and launch your vertical printing business in less than 12 weeks",
    },
  ],

  features: [
    {
      title: "Effortless Setup & Portability",
      description:
        "Designed for convenience, the printer breaks down into compact, easy-to-carry bags, making transportation a breeze. Set up in minutes and start printing anywhere.",
      image: `${CDN_URL}/machine/WallPen_099.jpg`,
    },
    {
      title: "Hardened Steel Vertical Drivetrain",
      description:
        "Built for precision and stability, the industrial-grade helical rack and pinion drivetrain ensures smooth, high-resolution prints. The sturdy platform base and precision wheels allow for easy adjustments on any surface.",
      image: `${CDN_URL}/machine/E2_002.jpg`,
    },
    {
      title: "Variable Printer Height",
      description:
        "Extendable up to 13 feet, our innovative vertical axis system and patented variable extensions make printing large-scale murals effortless. Adapt to any wall size with ease.",
      image: `${CDN_URL}/machine/Wallpen_12.jpg`,
    },
    {
      title: "Instantly Cured UV Ink",
      description:
        "Our advanced, solvent-free UV ink dries instantly upon printing, delivering scratch-resistant, water-resistant, and highly durable results with stunning color vibrancy.",
      image: `${CDN_URL}/machine/E2_013.jpg`,
    },
    {
      title: "Print Anywhere, Anytime",
      description:
        "Engineered for versatility, the printer is ready to go wherever you need it. Whether indoors or outdoors, simply position it, load your design, and start printing with unmatched speed and accuracy.",
      image: `${CDN_URL}/machine/0187ff885d95f7c3e68628f999ae989743a7e2ee77.jpg`,
    },
  ],

  setup: {
    title: "Easy Setup",
    description:
      "Time is money, especially printing time. The wallPen is designed to be operational in just 5 minutes.",
    details: [
      {
        title: "Transport Bags",
        description:
          "Six hand-sewn transport bags protect the wallPen during storage and transit. Lightweight and easy to carry.",
        icon: "BriefcaseIcon",
      },
      {
        title: "One Tool, 12 Screws, 5 Minutes",
        description:
          "Quick setup with minimal effort. All you need is one tool, 12 screws, and 5 minutes to start printing.",
        icon: "WrenchScrewdriverIcon",
      },
      {
        title: "Compact Design",
        description:
          "Designed to fit in a mid-size car. Transport all components at once with ease.",
        icon: "TruckIcon",
      },
      {
        title: "Setup Video",
        description: "Watch how easy it is to set up.",
        icon: "VideoCameraIcon",
      },
    ],
    setupVideo: `${CDN_URL}/videos/Bubble_Tea_Laden_(hochkant)_(1).mp4`,
  },

  ecoFriendly: {
    title: "Environmentally Friendly Printing",
    description:
      "We care about sustainability. wallPen uses eco-friendly materials and inks without sacrificing quality.",
    features: [
      {
        title: "Vegan Ink",
        description: "Our inks are vegan, ISO-certified, and made in Germany.",
        icon: "GlobeAltIcon",
      },
      {
        title: "Minimal Waste",
        description: "No waste due to stencils or foil remnants.",
        icon: "SparklesIcon",
      },
      {
        title: "Durable Prints",
        description:
          "Scratch-resistant, odorless, and harmless even in case of fire.",
        icon: "CheckCircleIcon",
      },
      {
        title: "No Solvents",
        description: "Solvent-free ink ensures safe, clean walls.",
        icon: "ShieldCheckIcon",
      },
      {
        title: "Scratch Resistant",
        description: "Ink resists scratches for lasting results.",
        icon: "WrenchScrewdriverIcon",
      },
      {
        title: "Fire Safe Prints",
        description: "Odorless and harmless even in case of fire.",
        icon: "FireIcon",
      },
    ],
  },

  // ✅ **Added this missing section**
  transitionImages: [
    {
      image: `${CDN_URL}/machine/WallPen_071.jpg`,
      alt: "WallPen in Action",
    },
    {
      image: `${CDN_URL}/machine/WallPen_105.jpg`,
      alt: "WallPen Setup",
    },
    {
      image: `${CDN_URL}/machine/WallPen_018.jpg`,
      alt: "WallPen Results",
    },
  ],

  pricing: {
    title: "Ready to Start Printing?",
    description:
      "Fill out the form to let us know you are interested in purchasing your own WallPen. Expect a call or text when we reach out to discuss your options.",
    price: "Starting at $45K",
    image: `${CDN_URL}/machine/DSC00892_Kopie2_kleiner.jpg`,
    form: {
      fields: [
        { label: "First Name", placeholder: "E.g. John" },
        { label: "Last Name", placeholder: "E.g. Doe" },
        { label: "Email Address", placeholder: "E.g. john@doe.com" },
        { label: "Phone Number", placeholder: "E.g. +1 3004005000" },
      ],
      checkbox: "Sign up to receive email communications.",
      buttonText: "Submit",
    },
  },
};

export default machine;
